import { API_HOST } from 'config/environment';
import { logger, ApiKey } from 'services';

const api_key = ApiKey.get();

export const cacheServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const worker = await navigator.serviceWorker.register(
        '/cache-worker-v1.2.js',
      );

      worker.active?.postMessage({
        host: API_HOST,
        api_key,
      });
    } catch (error) {
      logger.error('Service Worker registration failed', { error });
    }
  }
};

export const clearCache = () => caches.delete('rocketlane');

export const unregister = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.ready;

      registration.unregister();
    } catch (error) {
      logger.error('Failed to remove service worker', { error });
    }
  }
};
